<template>
    <div id='wine-club-header' class='container' :class="{'background-image' : show_background}">
        <div class='header-container' :class="{'header-padding' : add_padding}">
            <img class='logo' src="/images/logos/logo.png" @click='goToHome'> 
            <div  v-if='!loading' v-show='!hide_buttons' class='buttons-container'>
                <button v-show='!logged_in' @click='goToLogin' class='login-button'>Sign in</button>
                <a v-show='logged_in && !mobile_mode' class='account-link' @click='toGoAccount'>Manage My Subscription </a>
                <button v-show='logged_in && !mobile_mode' @click='logout' class='login-button'>Logout</button>
                <a v-show='logged_in && mobile_mode' class='account-link' @click='toGoAccount'><i class="fa-solid fa-user icon user-icon"></i> </a>
                <a  class='account-link'  v-show='logged_in && mobile_mode' @click='logout'><i class="fa-solid fa-arrow-right-from-bracket icon"></i></a>
            </div>
            <div v-if='loading' class='loading-container'>
                <Loading/>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import {checkAuth} from "@/global/modules/functions.js";
import Loading from '@/ecom/components/loading/Loading.vue';

export default {
    components: {DynamicImageContainer, Loading},
    props:{
        'show_background': {default: true},
        'add_padding': {default: true},
        'login_changed': {}
    },
    data(){
        return{
            hide_buttons: false,
            logged_in : false,
            loading: true,
            screen_size_check_timeout: null,
            mobile_mode: false
        }
    },
    methods:{
        goToLogin(){
            this.$router.push('/login?redirect_url=wine-club/members');
        },
        toGoAccount(){
            this.$router.push('/wine-club/members');
        },
        goToHome(){
            this.$router.push('/');
        },
        toGoLIIAccount(){
            this.$router.push('/lock-it-in/members');
        },
        async checkLoggedin(){
            this.loading = true;

            let response = await fetch(`/api/user/check-logged-in`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(results == true){
                    this.logged_in = true;
                }
            }

            this.loading = false;
        },
        hideShowElements(route){
            if(route == '/login' || route == '/login/'){
                this.hide_buttons = true;
            }

        },
        async logout(){
            let response = await fetch(`/api/user/logout`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({}),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.logged_in = false;
                window.location.href = '/';
            }
        },
        CheckMobileMode(){
            let wine_club_header = document.getElementById('wine-club-header');
            if(typeof wine_club_header !== 'undefined'){
                new ResizeObserver(()=>{
                    clearTimeout(this.screen_size_check_timeout);

                    this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                        if(wine_club_header.clientWidth <= 768){
                            this.mobile_mode = true;
                        }
                        else{
                            this.mobile_mode = false;
                        }
                    }, 1);
                }).observe(wine_club_header);
            }
        },
    },
    watch:{
      'login_changed': function(){
        this.checkLoggedin();
      }
    },
    mounted(){
        this.CheckMobileMode();
    },
    beforeMount(){
        this.checkLoggedin();
        this.hideShowElements(this.$route.path);
    }

}
</script>

<style lang="scss" scoped>
.container{
    width: 100%;
}

.background-image{
	position: relative;
	isolation: isolate;
}

.background-image::before{
	content: '';
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-image: url('/public/images/backgrounds/white-marble.jpg');
	background-size: cover;
	background-repeat: no-repeat;
	opacity: 0.2;
	z-index: 0;
	pointer-events: none;
}

.header-container{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
	position: relative;
	z-index: 1;
}

.header-padding{
    padding: 0px 96px;

    @media(max-width: 768px){
       padding: 0px 12px;
    }
}

.logo{
    height: 96px;
    cursor: pointer;

    @media(max-width: 768px){
        height: auto;
        width: 150px;
    }
}

.login-button{
        background: none;
        color: var(--black);
        border-radius: 30px;
        padding: 2px 30px;
        height: 42px;
        border: 1px solid var(--black);
        font-size: 0.9rem;
        cursor: pointer;
    }

    .buttons-container{
        display: flex;
        gap: 24px;
        align-items: center;

        @media(max-width: 768px){
            gap: 16px;
        }
    }

    .account-link{
        color: var(--black);
        cursor: pointer;
        &:hover{
            text-decoration: underline;
        }
    }

.loading-container{
    width: 25px;
    height: 25px;
    margin-right: 40px;
}

.switch-text{
    @media(max-width: 768px){
        font-size: 0.76rem;
        font-weight: 300;
    }
}

:deep(){
   .loader {
    width: inherit;
    height: inherit;
    border: 3px solid  var(--black);
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
}

.icon{
    font-size: 1.3rem;
    margin-right: 12px;
}
</style>
